/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IClinicalDictionaryType {
  id?: string;
  entryId?: string;
  dictType?: string;
  especiality?: string | null;
  dictDescription?: string | null;
  createdBy?: string;
  createDate?: number;
  lastUpdated?: number;
  lastModifiedBy?: string;
  active?: boolean;
  cursor?: number;
  microSec?: number;
  timestampEntry?: number;
}

export const defaultValue: Readonly<IClinicalDictionaryType> = {
  active: false,
};
